export default {"src":"/_next/static/media/credit-cards.ce814a2e.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};